import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function Yandex({
  fill = 'var(--color-cream)',
  width = 48,
  height = 48,
}: SvgTypesProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width={width} height={height} baseProfile="basic"><path fill="#ffca28" d="M43.79,18.14l-5.07,4.06C38.9,23.11,39,24.04,39,25c0,7.72-6.28,14-14,14s-14-6.28-14-14	c0-7.04,5.22-12.88,12-13.86V5.1C12.9,6.11,5,14.65,5,25c0,11.03,8.97,20,20,20s20-8.97,20-20C45,22.59,44.57,20.28,43.79,18.14z"/><circle cx="25" cy="25" r="7" fill="#f4511e"/><path fill="#f4511e" d="M39.99,11.77l-3.41,5.37c-1.79-2.63-4.46-4.63-7.58-5.56V5.4C33.33,6.28,37.17,8.57,39.99,11.77z"/><rect width="3" height="16" x="29" y="9" fill="#f4511e"/></svg>);
}
